import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useRef,
  useState,
  useMemo,
} from "react";
import { fnGetDataSet, fnGetTableById, fnSave } from "@shared/api/restApi";
import {
  fnPrintByReport,
  getAutoSlip,
  getInitPopUpData,
  getbsnget,
} from "@shared/utils/CommonUtils";
import { showDialog } from "@widgets/CommonDialog";
import { global } from "@shared/libs/Global";
import SnGrid from "@shared/components/GridV2/SnGrid";
import SnTab from "@shared/components/SnTab";
import SnForm from "@widgets/SnForm";
import SnButton from "@shared/components/SnButton";
import SnTabHeader from "@shared/components/SnTabHeader";
import SnResizeBar from "@shared/components/SnResizeBar";
import SnBarcodeBox from "@shared/components/SnBarcodeBox";
import SnFileUploadBox from "@shared/components/SnFileUploadBox";
import { menuInfo } from "@shared/type/CommonType";
import { dateToString } from "@shared/utils/DateUtils";
import {
  buildConshInsertRows,
  buildManualConslInsertRows,
  findInvalidConslIssueKeyRow,
  findYMaterialShortage,
  validateMaterialRowsBeforeSaveCommon,
} from "./WP_SAVE_COMMON";
import {
  TAB_MATERIAL,
  TAB_REJECT,
  collectRowsFromGrid,
  getPartAvailableQty,
  isMatlRowPending,
  isYnY,
  makePartKey,
  normalizeBarcode,
  resolveWrkRegPopupTables,
  sumRunQtyFromRows,
  getNowTime,
} from "./WP_POPUP_COMMON";
import { buildPrdLabelParams } from "../PRD_LABEL_PRINT";

interface popupProps {
  selectedData?: any;
  Menuprops?: menuInfo;
}

const WP3003 = forwardRef(
  ({ selectedData, Menuprops }: popupProps, ref: React.Ref<any>) => {
    const { userInfo } = global();
    const formPanel1Ref = useRef<any>(null);
    const formPanel2Ref = useRef<any>(null);
    const popupRootRef = useRef<HTMLDivElement>(null);
    const panel2WrapperRef = useRef<HTMLDivElement | null>(null);
    const prodBarcodeRef = useRef<HTMLInputElement | null>(null);
    const gridRefs = useRef<{ [key: string]: React.RefObject<any> }>({
      grid1: React.createRef(),
      grid2: React.createRef(),
      grid3: React.createRef(),
    });
    const getGridCurrent = (key: "grid1" | "grid2" | "grid3") => {
      return gridRefs.current[key].current;
    };
    const GRID_NO_EVENT = "noEvent";
    const isRunViewMode = !!(selectedData?.no_run || "").toString().trim();

    const [panel1Controls, setPanel1Controls] = useState<any[]>([]);
    const [panel2Controls, setPanel2Controls] = useState<any[]>([]);
    const [panel1Data, setPanel1Data] = useState<any>({});
    const [panel2Data, setPanel2Data] = useState<any>({});
    const [columns, setColums] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
    });
    const [dataSources, setDataSources] = useState<any>({
      grid1: [],
      grid2: [],
      grid3: [],
    });
    const [selectedDocu, setSelectedDocu] = useState<string>("");
    const [selectedLineDocu, setSelectedLineDocu] = useState<number>(0);
    const [tab, setTab] = useState<string>(TAB_REJECT);
    // 2번 테이블: 공정별 투입자재 기준 리스트(yn_matl_check/qt_unit)
    const [matlCheckRows, setMatlCheckRows] = useState<any[]>([]);
    const [popupParentEl, setPopupParentEl] = useState<HTMLElement | null>(
      null
    );
    // 3번 테이블: partslist 버퍼(재고/자동주입용)
    const [partsListRows, setPartsListRows] = useState<any[]>([]);
    const partsListRef = useRef<any[]>([]);
    const [hasMatlCheck, setHasMatlCheck] = useState<boolean>(false);
    // 한글 주석: 재작업(fg_run=A) 실적은 정상 실적에서 양품+불량 기준으로 자재를 이미 소진했으므로
    // 투입자재 기준 리스트를 비워 스캔 요구·소요량/재고 부족 검증·prd_consl 생성을 모두 건너뛴다.
    const isRework = (selectedData?.fg_run || "S").toString().toUpperCase() === "A";
    const pendingRunlQueueRef = useRef<any[]>([]);
    const shouldRestoreProdFocusRef = useRef<boolean>(false);
    const isAutoSavingRef = useRef<boolean>(false);
    const hasRunlInspRowsRef = useRef<boolean>(false);
    const ISSUE_REMAIN_QUERY_ID = "fn_get_prd_issuel_remain";
    const [prodBarcode, setProdBarcode] = useState<string>("");
    const [fgGoodBad, setFgGoodBad] = useState<string>("G");
    const toReadOnlyControls = (controls: any[]) => {
      if (!isRunViewMode) return controls;
      return (Array.isArray(controls) ? controls : []).map((control: any) => ({
        ...control,
        dc_editcon: "true",
      }));
    };

    // 제품실적 스캔 입력칸 포커스
    const focusProductBarcode = () => {
      setTimeout(() => {
        prodBarcodeRef.current?.focus();
        prodBarcodeRef.current?.select?.();
      }, 50);
    };

    const getCurrentRunlLink = () => {
      const focused = gridRefs.current["grid1"].current?.focusedRowNode?.();
      if (focused?.data) {
        return {
          no_run: focused.data.no_run || "",
          no_line_run: Number(focused.data.no_line ?? 0) || 0,
          no_barcode_item: (focused.data.no_sn || "").toString(),
        };
      }

      let last: any = null;
      gridRefs.current["grid1"].current?.forEachNode?.((node: any) => {
        if (!node?.data) return;
        if (!last) {
          last = node.data;
          return;
        }
        const currNoLine = Number(node.data.no_line ?? 0) || 0;
        const lastNoLine = Number(last.no_line ?? 0) || 0;
        if (currNoLine >= lastNoLine) {
          last = node.data;
        }
      });

      return {
        no_run: last?.no_run || "",
        no_line_run: Number(last?.no_line ?? 0) || 0,
        no_barcode_item: (last?.no_sn || "").toString(),
      };
    };

    // grid1의 no_line(runl line)로 연결키(no_run/no_line_run/no_barcode_item)를 찾는다.
    const getRunlLinkByNoLineRun = (noLineRun: number) => {
      if (!noLineRun) return null;
      let found: any = null;
      gridRefs.current["grid1"].current?.forEachNode?.((node: any) => {
        if (found) return;
        const row = node?.data || {};
        if (Number(row.no_line ?? 0) !== Number(noLineRun)) return;
        found = {
          no_run: row.no_run || "",
          no_line_run: Number(row.no_line ?? 0) || 0,
          no_barcode_item: (row.no_sn || "").toString(),
        };
      });
      return found;
    };

    // partslist의 qt_use를 누적 갱신한다.
    // partslist의 qt_use를 키별로 누적 갱신한다.
    const applyPartUseMap = (useMap: Map<string, number>) => {
      if (!useMap || useMap.size < 1) return;
      const next = (partsListRef.current || []).map((row: any) => {
        const key = makePartKey(row);
        if (!key) return row;
        const addUse = useMap.get(key) || 0;
        if (addUse === 0) return row;
        const nextQtUseRaw = (Number(row?.qt_use ?? 0) || 0) + addUse;
        const nextQtUse = nextQtUseRaw < 0 ? 0 : nextQtUseRaw;
        return {
          ...row,
          qt_use: nextQtUse,
          // qt_use 누적 결과로 즉시 yn_check를 동기화한다.
          // 삭제 등으로 qt_use가 0 이하가 되면 N으로 원복된다.
          yn_check: nextQtUse > 0 ? "Y" : "N",
        };
      });
      partsListRef.current = next;
      setPartsListRows(next);
    };

    // grid2 전체 row를 수집한다.
    // api가 일시적으로 비어있는 타이밍에는 getChange(insert/update)를 fallback으로 사용한다.
    const getAllGrid2Rows = () => {
      const grid2Ref = gridRefs.current["grid2"].current;
      return collectRowsFromGrid(grid2Ref, dataSources?.grid2, true);
    };

    const hasPendingMaterialForRun = (noLineRun: number) => {
      if (!noLineRun) return false;
      return getAllGrid2Rows().some((row: any) => {
        if (Number(row?.no_line_run ?? 0) !== noLineRun) return false;
        return isMatlRowPending(row);
      });
    };

    // 전체 실적행 기준으로 아직 자재바코드가 미입력된 행이 있는지 확인
    const hasAnyPendingMaterial = () => {
      return getAllGrid2Rows().some((row: any) => isMatlRowPending(row));
    };

    // 미입력 대상 중 fg_unit이 LOT/SN인 첫 번째 품목을 반환한다.
    const getFirstPendingBarcodeTarget = () => {
      const rows = getAllGrid2Rows();
      const pending = rows.find((row: any) => {
        if (!isMatlRowPending(row)) return false;
        const fgUnit = (row?.fg_unit || "").toString().trim().toUpperCase();
        return fgUnit === "LOT" || fgUnit === "SN";
      });
      return pending || null;
    };

    // WP3003(자재 선스캔): 첫 스캔 전에 grid2 pending 행이 없으면 작업지시 자재 기준으로 시드한다.
    const ensureInitialPendingMaterialRows = () => {
      const existingRows = getAllGrid2Rows();
      if (existingRows.length > 0) return;
      if (!hasMatlCheck) return;

      const yMatls = (matlCheckRows || []).filter((r: any) =>
        isYnY(r?.yn_matl_check)
      );
      if (yMatls.length < 1) return;

      const seedRows = yMatls
        .map((matl: any) => {
          const qty = Number(matl?.qt_unit ?? 0) || 0;
          if (qty <= 0) return null;
          const partMatched = (partsListRef.current || []).find((p: any) => {
            if (
              (p?.cd_matl || "").toString().trim() !==
              (matl?.cd_matl || "").toString().trim()
            ) {
              return false;
            }
            const pBill = Number(p?.no_line_bill ?? 0) || 0;
            const mBill = Number(matl?.no_line_bill ?? 0) || 0;
            if (pBill > 0 && mBill > 0) {
              return pBill === mBill;
            }
            return true;
          });
          const fgUnitSeedRaw = (partMatched?.fg_unit || matl?.fg_unit || "LOT")
            .toString()
            .trim()
            .toUpperCase();
          const fgUnitSeed = fgUnitSeedRaw === "SN" ? "SN" : "LOT";
          return {
            ...matl,
            no_run: "",
            no_line_run: 1,
            no_barcode_item: "",
            fg_unit: fgUnitSeed,
            no_barcode: "",
            no_sn: "",
            no_lot: "",
            no_io: "",
            no_line_io: 0,
            no_line_lot_io: 0,
            no_origin: "",
            no_line_origin: 0,
            no_line_lot_origin: 0,
            no_ct: "",
            no_plt: "",
            cd_wh: "",
            qt: qty,
            qt_w: qty,
            qt_b: 0,
          };
        })
        .filter(Boolean) as any[];

      if (seedRows.length < 1) return;
      const grid2 = getGridCurrent("grid2");
      seedRows.forEach((row: any) => {
        grid2?.addRow?.(row, false);
      });
      setDataSources((prev: any) => ({
        ...prev,
        grid2: [...seedRows],
      }));
    };

    const buildInitialGrid2Rows = (
      matlCheckList: any[],
      partsList: any[],
      runlInspList: any[]
    ) => {
      const yMatls = (matlCheckList || []).filter((r: any) =>
        isYnY(r?.yn_matl_check)
      );
      if (yMatls.length < 1) return [] as any[];

      const scannedRows = (runlInspList || []).filter((r: any) =>
        isYnY(r?.yn_check)
      );

      return yMatls
        .map((matl: any) => {
          const qty = Number(matl?.qt_unit ?? 0) || 0;
          if (qty <= 0) return null;

          const partMatched = (partsList || []).find((p: any) => {
            if (
              (p?.cd_matl || "").toString().trim() !==
              (matl?.cd_matl || "").toString().trim()
            ) {
              return false;
            }
            const pBill = Number(p?.no_line_bill ?? 0) || 0;
            const mBill = Number(matl?.no_line_bill ?? 0) || 0;
            if (pBill > 0 && mBill > 0) return pBill === mBill;
            return true;
          });

          const scanned = scannedRows.find((r: any) => {
            if (
              (r?.cd_matl || "").toString().trim() !==
              (matl?.cd_matl || "").toString().trim()
            ) {
              return false;
            }
            const rBill = Number(r?.no_line_bill ?? 0) || 0;
            const mBill = Number(matl?.no_line_bill ?? 0) || 0;
            if (rBill > 0 && mBill > 0) return rBill === mBill;
            return true;
          });

          const fgUnitRaw = (
            scanned?.fg_unit ||
            partMatched?.fg_unit ||
            matl?.fg_unit ||
            "LOT"
          )
            .toString()
            .trim()
            .toUpperCase();
          const fgUnit = fgUnitRaw === "SN" ? "SN" : "LOT";
          const scannedBarcode = (
            scanned?.no_barcode ||
            scanned?.no_sn ||
            scanned?.no_lot ||
            ""
          )
            .toString()
            .trim();

          return {
            ...matl,
            nm_matl: partMatched?.nm_matl ?? matl?.nm_matl ?? "",
            dc_matl_spec: partMatched?.dc_matl_spec ?? matl?.dc_matl_spec ?? "",
            dc_matl_unit: partMatched?.dc_matl_unit ?? matl?.dc_matl_unit ?? "",
            no_run: scanned?.no_run || "",
            no_line_run: Number(scanned?.no_line_run ?? 0) || 1,
            no_barcode_item: (scanned?.no_barcode_item || "").toString(),
            fg_unit: fgUnit,
            // no_barcode: scannedBarcode,
            // no_sn:
            //   fgUnit === "SN"
            //     ? (scanned?.no_sn || scannedBarcode || "").toString()
            //     : "",
            // no_lot:
            //   fgUnit === "LOT"
            //     ? (scanned?.no_lot || scannedBarcode || "").toString()
            //     : "",
            no_sn: "",
            no_barcode: "",
            no_lot: "",
            no_io: scanned?.no_io || "",
            no_line_io: Number(scanned?.no_line_io ?? 0) || 0,
            no_line_lot_io: Number(scanned?.no_line_lot_io ?? 0) || 0,
            no_origin: scanned?.no_origin || "",
            no_line_origin: Number(scanned?.no_line_origin ?? 0) || 0,
            no_line_lot_origin: Number(scanned?.no_line_lot_origin ?? 0) || 0,
            no_ct: scanned?.no_ct || "",
            no_plt: scanned?.no_plt || "",
            cd_wh: scanned?.cd_wh || "",
            qt: qty,
            qt_w: qty,
            qt_b: 0,
          };
        })
        .filter(Boolean) as any[];
    };

    // 현재 입력 바코드가 partslist 기준 자재(SN/LOT)인지 판별
    const isMaterialBarcodeValue = (barcodeValue: string) => {
      const v = normalizeBarcode(barcodeValue);
      if (!v) return false;
      return (partsListRef.current || []).some((p: any) => {
        const fg = (p?.fg_unit || "").toString().trim().toUpperCase();
        if (fg === "SN") return normalizeBarcode(p?.no_sn) === v;
        if (fg === "LOT") return normalizeBarcode(p?.no_lot) === v;
        return false;
      });
    };

    const prepareMaterialRowsForCurrentRunl = (
      productBarcode: string,
      noLineRun?: number
    ) => {
      if (!hasMatlCheck) return;
      const runlLink = noLineRun
        ? getRunlLinkByNoLineRun(noLineRun)
        : getCurrentRunlLink();
      if (!runlLink || !runlLink.no_line_run) return;

      // 이미 생성된 실적행 자재 준비 rows가 있으면 중복 생성하지 않음
      let alreadyPrepared = false;
      getGridCurrent("grid2")?.forEachNode?.((node: any) => {
        if (alreadyPrepared) return;
        if (Number(node?.data?.no_line_run ?? 0) === runlLink.no_line_run) {
          alreadyPrepared = true;
        }
      });
      if (alreadyPrepared) return;

      const yMatls = matlCheckRows.filter((r: any) => isYnY(r?.yn_matl_check));
      if (yMatls.length < 1) return;

      const addRows: any[] = [];
      const useMap = new Map<string, number>();

      yMatls.forEach((matl: any) => {
        // 한 건 실적(no_line_run 1건) 기준 소요량은 qt_unit만 사용한다.
        let remainNeed = Number(matl.qt_unit ?? 0) || 0;
        if (remainNeed <= 0) return;

        const pb = normalizeBarcode(productBarcode);
        // 같은 팝업 세션 내에서 직전 실적(no_line_run이 더 작은 행)에서
        // 동일 자재항번(no_line_bill)에 스캔/자동입력된 바코드를 우선 재사용한다.
        const prevAssignedBarcode = (() => {
          const currentRun = Number(runlLink.no_line_run ?? 0) || 0;
          const prevRows = getAllGrid2Rows().filter((r: any) => {
            if (
              (r.cd_matl || "").toString().trim() !==
              (matl.cd_matl || "").toString().trim()
            )
              return false;
            if (Number(r.no_line_bill ?? 0) !== Number(matl.no_line_bill ?? 0))
              return false;
            const runNo = Number(r.no_line_run ?? 0) || 0;
            if (runNo <= 0 || runNo >= currentRun) return false;
            return !!(r.no_barcode || "").toString().trim();
          });
          if (prevRows.length < 1) return "";
          prevRows.sort(
            (a: any, b: any) =>
              (Number(b.no_line_run ?? 0) || 0) -
              (Number(a.no_line_run ?? 0) || 0)
          );
          return (prevRows[0].no_barcode || "").toString().trim();
        })();
        const candidates = (partsListRef.current || [])
          .filter((p: any) => {
            if (p.cd_matl !== matl.cd_matl) return false;
            // no_line_bill이 양쪽에 존재하면 반드시 같은 자재항번만 허용
            if (p.no_line_bill != null && matl.no_line_bill != null) {
              return (
                Number(p.no_line_bill ?? 0) === Number(matl.no_line_bill ?? 0)
              );
            }
            return true;
          })
          .sort((a: any, b: any) => {
            // 기본 우선순위는 yn_check='Y'만 사용
            const aChecked =
              (a?.yn_check || "").toString().toUpperCase() === "Y" ? 0 : 1;
            const bChecked =
              (b?.yn_check || "").toString().toUpperCase() === "Y" ? 0 : 1;
            if (aChecked !== bChecked) {
              return aChecked - bChecked;
            }
            return 0;
          });

        const isProductMatchedPart = (part: any) => {
          const partNoSn = normalizeBarcode(part?.no_sn);
          const partNoLot = normalizeBarcode(part?.no_lot);
          const partNoBarcode = normalizeBarcode(part?.no_barcode);
          return (
            !!pb &&
            (partNoSn === pb || partNoLot === pb || partNoBarcode === pb)
          );
        };

        // 제품바코드와 동일한 자재바코드가 있으면, 정렬/순서와 무관하게 먼저 강제 매칭
        let consumedProductPartKey = "";
        if (pb) {
          const productPart = candidates.find((part: any) => {
            if (!isProductMatchedPart(part)) return false;
            const key = makePartKey(part);
            const alreadyAddedUse = key ? useMap.get(key) || 0 : 0;
            return getPartAvailableQty(part, alreadyAddedUse) > 0;
          });

          if (productPart && remainNeed > 0) {
            const partKey = makePartKey(productPart);
            const alreadyAddedUse = partKey ? useMap.get(partKey) || 0 : 0;
            const available = getPartAvailableQty(productPart, alreadyAddedUse);
            const useQty = Math.min(remainNeed, available);
            const fgUnit = (productPart.fg_unit || "").toString().toUpperCase();
            const autoBarcode = (productBarcode || "").toString();
            const autoNoSn = fgUnit === "SN" ? autoBarcode : "";
            const autoNoLot = fgUnit === "LOT" ? autoBarcode : "";

            addRows.push({
              ...matl,
              nm_matl:
                matl.nm_matl ??
                matl.nm_item ??
                productPart.nm_matl ??
                productPart.nm_item ??
                "",
              dc_matl_spec:
                matl.dc_matl_spec ??
                matl.dc_item_spec ??
                productPart.dc_matl_spec ??
                productPart.dc_item_spec ??
                "",
              dc_matl_unit:
                matl.dc_matl_unit ??
                matl.dc_item_unit ??
                productPart.dc_matl_unit ??
                productPart.dc_item_unit ??
                "",
              no_run: runlLink.no_run,
              no_line_run: runlLink.no_line_run,
              no_barcode_item: productBarcode || runlLink.no_barcode_item || "",
              fg_unit: productPart.fg_unit || matl.fg_unit,
              no_barcode: autoBarcode,
              no_sn: autoNoSn,
              no_lot: autoNoLot,
              no_io: productPart.no_io || "",
              no_line_io: productPart.no_line_io ?? 0,
              no_line_lot_io: productPart.no_line_lot_io ?? 0,
              no_origin: productPart.no_origin || "",
              no_line_origin: productPart.no_line_origin ?? 0,
              no_line_lot_origin: productPart.no_line_lot_origin ?? 0,
              no_ct: productPart.no_ct || "",
              no_plt: productPart.no_plt || "",
              cd_wh: productPart.cd_wh || "",
              qt: useQty,
              qt_w: useQty,
              qt_b: 0,
            });

            if (partKey) {
              useMap.set(partKey, (useMap.get(partKey) || 0) + useQty);
              consumedProductPartKey = partKey;
            }
            remainNeed -= useQty;
          }
        }

        // 제품바코드 동일건이 없으면, 직전 실적에서 사용한 동일 자재항번 바코드를 우선 재사용
        if (remainNeed > 0 && !consumedProductPartKey && prevAssignedBarcode) {
          const prevPart = candidates.find((part: any) => {
            const fg = (part.fg_unit || "").toString().toUpperCase();
            const prev = normalizeBarcode(prevAssignedBarcode);
            const sn = normalizeBarcode(part?.no_sn);
            const lot = normalizeBarcode(part?.no_lot);
            if (fg === "SN" && sn !== prev) return false;
            if (fg === "LOT" && lot !== prev) return false;
            const key = makePartKey(part);
            const alreadyAddedUse = key ? useMap.get(key) || 0 : 0;
            return getPartAvailableQty(part, alreadyAddedUse) > 0;
          });

          if (prevPart) {
            const partKey = makePartKey(prevPart);
            const alreadyAddedUse = partKey ? useMap.get(partKey) || 0 : 0;
            const available = getPartAvailableQty(prevPart, alreadyAddedUse);
            const useQty = Math.min(remainNeed, available);
            const fgUnit = (prevPart.fg_unit || "").toString().toUpperCase();
            const autoBarcode = prevAssignedBarcode;
            const autoNoSn = fgUnit === "SN" ? autoBarcode : "";
            const autoNoLot = fgUnit === "LOT" ? autoBarcode : "";

            addRows.push({
              ...matl,
              nm_matl:
                matl.nm_matl ??
                matl.nm_item ??
                prevPart.nm_matl ??
                prevPart.nm_item ??
                "",
              dc_matl_spec:
                matl.dc_matl_spec ??
                matl.dc_item_spec ??
                prevPart.dc_matl_spec ??
                prevPart.dc_item_spec ??
                "",
              dc_matl_unit:
                matl.dc_matl_unit ??
                matl.dc_item_unit ??
                prevPart.dc_matl_unit ??
                prevPart.dc_item_unit ??
                "",
              no_run: runlLink.no_run,
              no_line_run: runlLink.no_line_run,
              no_barcode_item: productBarcode || runlLink.no_barcode_item || "",
              fg_unit: prevPart.fg_unit || matl.fg_unit,
              no_barcode: autoBarcode,
              no_sn: autoNoSn,
              no_lot: autoNoLot,
              no_io: prevPart.no_io || "",
              no_line_io: prevPart.no_line_io ?? 0,
              no_line_lot_io: prevPart.no_line_lot_io ?? 0,
              no_origin: prevPart.no_origin || "",
              no_line_origin: prevPart.no_line_origin ?? 0,
              no_line_lot_origin: prevPart.no_line_lot_origin ?? 0,
              no_ct: prevPart.no_ct || "",
              no_plt: prevPart.no_plt || "",
              cd_wh: prevPart.cd_wh || "",
              qt: useQty,
              qt_w: useQty,
              qt_b: 0,
            });

            if (partKey) {
              useMap.set(partKey, (useMap.get(partKey) || 0) + useQty);
              consumedProductPartKey = partKey;
            }
            remainNeed -= useQty;
          }
        }

        for (const part of candidates) {
          if (remainNeed <= 0) break;
          const partKey = makePartKey(part);
          if (consumedProductPartKey && partKey === consumedProductPartKey) {
            continue;
          }
          const alreadyAddedUse = partKey ? useMap.get(partKey) || 0 : 0;
          const available = getPartAvailableQty(part, alreadyAddedUse);
          if (available <= 0) continue;
          const useQty = Math.min(remainNeed, available);
          const fgUnit = (part.fg_unit || "").toString().toUpperCase();
          const isYnCheckAuto =
            (part?.yn_check || "").toString().toUpperCase() === "Y";
          const autoBarcode = isYnCheckAuto
            ? fgUnit === "SN"
              ? (part.no_sn || "").toString()
              : fgUnit === "LOT"
                ? (part.no_lot || "").toString()
                : ""
            : "";
          const isAutoAssigned = !!autoBarcode;
          // 표시용 no_barcode와 저장용 no_sn/no_lot를 관리구분 기준으로 동일하게 맞춘다.
          const autoNoSn = isAutoAssigned && fgUnit === "SN" ? autoBarcode : "";
          const autoNoLot =
            isAutoAssigned && fgUnit === "LOT" ? autoBarcode : "";

          addRows.push({
            ...matl,
            nm_matl:
              matl.nm_matl ??
              matl.nm_item ??
              part.nm_matl ??
              part.nm_item ??
              "",
            dc_matl_spec:
              matl.dc_matl_spec ??
              matl.dc_item_spec ??
              part.dc_matl_spec ??
              part.dc_item_spec ??
              "",
            dc_matl_unit:
              matl.dc_matl_unit ??
              matl.dc_item_unit ??
              part.dc_matl_unit ??
              part.dc_item_unit ??
              "",
            no_run: runlLink.no_run,
            no_line_run: runlLink.no_line_run,
            no_barcode_item: productBarcode || runlLink.no_barcode_item || "",
            fg_unit: part.fg_unit || matl.fg_unit,
            no_barcode: autoBarcode,
            // 자동입력 2가지 케이스에서만 원천키/바코드를 즉시 주입한다.
            // 나머지는 스캔 시점(onMaterialBarcodeScan)에 채운다.
            no_sn: autoNoSn,
            no_lot: autoNoLot,
            no_io: isAutoAssigned ? part.no_io || "" : "",
            no_line_io: isAutoAssigned ? (part.no_line_io ?? 0) : 0,
            no_line_lot_io: isAutoAssigned ? (part.no_line_lot_io ?? 0) : 0,
            no_origin: isAutoAssigned ? part.no_origin || "" : "",
            no_line_origin: isAutoAssigned ? (part.no_line_origin ?? 0) : 0,
            no_line_lot_origin: isAutoAssigned
              ? (part.no_line_lot_origin ?? 0)
              : 0,
            no_ct: isAutoAssigned ? part.no_ct || "" : "",
            no_plt: isAutoAssigned ? part.no_plt || "" : "",
            cd_wh: isAutoAssigned ? part.cd_wh || "" : "",
            qt: useQty,
            qt_w: useQty,
            qt_b: 0,
          });
          // qt_use 누적 정책:
          // 1) 자동입력 행(yn_check='Y' 또는 제품바코드 동일건)은 생성 시점에 누적
          // 2) 수동스캔 행은 스캔 성공 시점(onMaterialBarcodeScan)에서 누적
          if (partKey && isAutoAssigned) {
            useMap.set(partKey, (useMap.get(partKey) || 0) + useQty);
          }
          remainNeed -= useQty;
        }

        // 잔량이 부족하면 바코드 공란 행을 추가해 추가 스캔 가능하게 유지
        if (remainNeed > 0) {
          addRows.push({
            ...matl,
            nm_matl: matl.nm_matl ?? matl.nm_item ?? "",
            dc_matl_spec: matl.dc_matl_spec ?? matl.dc_item_spec ?? "",
            dc_matl_unit: matl.dc_matl_unit ?? matl.dc_item_unit ?? "",
            no_run: runlLink.no_run,
            no_line_run: runlLink.no_line_run,
            no_barcode_item: productBarcode || runlLink.no_barcode_item || "",
            no_barcode: "",
            no_sn: "",
            no_lot: "",
            no_io: "",
            no_line_io: 0,
            no_line_lot_io: 0,
            no_origin: "",
            no_line_origin: 0,
            no_line_lot_origin: 0,
            no_ct: "",
            no_plt: "",
            cd_wh: "",
            qt: remainNeed,
            qt_w: remainNeed,
            qt_b: 0,
          });
        }
      });

      if (addRows.length > 0) {
        const grid2 = getGridCurrent("grid2");
        addRows.forEach((row: any) => {
          grid2?.addRow?.(row, false);
        });
        // 생성된 투입자재행 수량만큼 partslist.qt_use 누적
        applyPartUseMap(useMap);
        setDataSources((prev: any) => ({
          ...prev,
          grid2: [
            ...(Array.isArray(prev?.grid2) ? prev.grid2 : []),
            ...addRows,
          ],
        }));
      }
    };

    const focusBarcodeInputWithRetry = (attempt = 0) => {
      const input = prodBarcodeRef.current;
      if (input) {
        input.focus();
        input.select?.();
        return;
      }
      if (attempt < 3) {
        setTimeout(() => focusBarcodeInputWithRetry(attempt + 1), 60);
      }
    };
    const restoreBarcodeFocus = () => {
      shouldRestoreProdFocusRef.current = true;
      setTimeout(() => focusBarcodeInputWithRetry(), 60);
      setTimeout(() => focusBarcodeInputWithRetry(), 180);
    };
    const onGridCellFocusedKeepBarcode = () => {
      restoreBarcodeFocus();
    };

    // Grid1 + pending insert rows 기준으로 중복 바코드를 체크한다.
    const isDuplicateBarcode = (barcodeValue: string, fgUnit: string) => {
      const value = (barcodeValue || "").toString().trim();
      if (!value) return false;

      const unit = (fgUnit || "").toString().toUpperCase();
      const key = unit === "SN" ? "no_sn" : unit === "LOT" ? "no_lot" : "";
      const isSame = (row: any) => {
        const byKey = key ? (row?.[key] || "").toString().trim() : "";
        const byBarcode = (row?.barcode || "").toString().trim();
        return byKey === value || byBarcode === value;
      };

      const activeNoLineRun =
        Number(getCurrentRunlLink()?.no_line_run ?? 0) || 0;
      let dup = false;
      gridRefs.current["grid1"].current?.forEachNode?.((node: any) => {
        if (isSame(node.data)) {
          dup = true;
        }
      });
      if (dup) return true;

      const changes = gridRefs.current["grid1"].current?.getChange?.() || {};
      const inserts = changes.insert || [];
      if (Array.isArray(inserts) && inserts.some(isSame)) {
        return true;
      }

      return false;
    };

    // 바코드 서버 유효성 체크(fn_prd_run_barcode_check_01).
    // st_proc가 S가 아니면 dc_msg를 표시하고 중단한다.
    const validateBarcode = async (barcodeValue: string) => {
      try {
        const panel1 = formPanel1Ref.current?.getFormdata?.() || {};
        const panel2 = formPanel1Ref.current?.getFormdata?.() || {};
        const payload = {
          id: "fn_prd_run_barcode_check_01",
          params: {
            cd_firm: userInfo.cd_firm,
            no_wo: panel1.no_wo || selectedData?.no_wo,
            cd_item: panel1.cd_item || "",
            cd_op: panel1.cd_op || "",
            cd_op_pre: panel1.cd_op_pre || "",
            fg_run: panel2.fg_run || "",
            no_barcode: barcodeValue,
          },
        };

        const result: any = await fnGetTableById(payload);
        const rows = Array.isArray(result) ? result : [];
        if (rows.length < 1) {
          await showDialog("alter", "바코드 유효성 체크 결과가 없습니다.");
          return null;
        }

        const stProc = (rows[0]?.st_proc || "").toString().toUpperCase();
        if (stProc !== "S") {
          await showDialog(
            "alter",
            rows[0]?.dc_msg || "바코드 유효성 체크에 실패했습니다."
          );
          return null;
        }

        return rows;
      } catch (error: any) {
        await showDialog(
          "error",
          error?.message || "유효성 체크에 실패했습니다."
        );
        return null;
      }
    };

    // 바코드 1건 입력 시 유효성 결과 row 수만큼 runl 행을 추가한다.
    // 최초 스캔에서는 fg_run을 panel3에 세팅하고, 이후 혼용은 차단한다.
    const addRunlRowByBarcode = async (
      barcodeValue: string,
      goodBad: string
    ) => {
      const panel2 = formPanel2Ref.current?.getFormdata?.() || {};
      const panel1 = formPanel1Ref.current?.getFormdata?.() || {};
      const fgUnit = (panel1.fg_unit || "").toString();
      const fgGoodBad = (goodBad || "G").toString();
      const checkRows = await validateBarcode(barcodeValue);
      if (!checkRows) return 0;

      const returnFgRun = (checkRows[0]?.fg_run || "").toString();
      const currentFgRun = (panel2.fg_run || "").toString();
      const displayedCount =
        getGridCurrent("grid1")?.getDisplayedRowCount?.() || 0;
      const isFirstScan = displayedCount === 0;

      if (isFirstScan) {
        if (returnFgRun) {
          await formPanel2Ref.current?.setDataValue?.(
            "fg_run",
            returnFgRun,
            "noEvent"
          );
        }
      } else if (
        returnFgRun &&
        currentFgRun &&
        returnFgRun.toUpperCase() !== currentFgRun.toUpperCase()
      ) {
        await showDialog(
          "alter",
          "[실적구분 혼용 불가] 기존 실적 저장 후 다시 시도해 주세요."
        );
        return 0;
      }

      pendingRunlQueueRef.current = checkRows.map((row: any) => ({
        barcodeValue,
        fgUnit,
        fgGoodBad,
        noRun: panel2.no_run,
        noRunPrev: row?.no_run_pre || "",
      }));

      const addCount = pendingRunlQueueRef.current.length;
      for (let i = 0; i < addCount; i++) {
        gridRefs.current["grid1"].current?.addRow();
      }
      return addCount;
    };

    // grid1(생산실적) 현재 행 기준으로 패널 실적수량을 다시 계산한다.
    // 누적이 아니라 전수 합산이라 저장 후 초기화나 행 증감과 어긋나지 않는다.
    // 조회모드에서는 서버가 내려준 prd_runh 값을 덮어쓰지 않도록 건너뛴다.
    const recalcRunQtyToPanel = async () => {
      if (isRunViewMode) return;
      const rows: any[] = [];
      gridRefs.current["grid1"].current?.forEachNode?.((node: any) => {
        if (node?.data) rows.push(node.data);
      });
      const { qtW, qtB, qt } = sumRunQtyFromRows(rows);
      await formPanel2Ref.current?.setDataValue?.("qt_w", qtW, GRID_NO_EVENT);
      await formPanel2Ref.current?.setDataValue?.("qt_b", qtB, GRID_NO_EVENT);
      await formPanel2Ref.current?.setDataValue?.("qt", qt, GRID_NO_EVENT);
    };

    // panel2(바코드/양불) 값 변경 이벤트.
    // barcode 엔터 입력 시 중복체크 -> 유효성검사 -> 행추가 -> 수량갱신 순으로 처리한다.
    const handleProductionBarcodeSubmit = async (rawBarcode?: string) => {
      const barcodeValue = (rawBarcode != null ? rawBarcode : prodBarcode)
        .toString()
        .trim();
      if (!barcodeValue) return;
      if (isAutoSavingRef.current) return;

      // WP3003: 바코드 입력은 자재 스캔으로만 처리한다.
      ensureInitialPendingMaterialRows();
      const materialOnlyOk = await onMaterialBarcodeScan(barcodeValue, true);
      if (!materialOnlyOk) {
        const target = getFirstPendingBarcodeTarget();
        if (target) {
          const targetLabel =
            (target?.nm_matl || "").toString().trim() ||
            (target?.cd_matl || "").toString().trim() ||
            "대상 품목";
          await showDialog("alter", `${targetLabel}의 바코드를 입력하세요.`);
        } else {
          await showDialog(
            "alter",
            "해당 자재는 이미 필요수량이 모두 스캔되었습니다."
          );
        }
      }
      setProdBarcode("");
      shouldRestoreProdFocusRef.current = true;
      if (materialOnlyOk && !hasAnyPendingMaterial()) {
        await autoSaveAndRefresh();
      }
      return;

      const runCount = getGridCurrent("grid1")?.getDisplayedRowCount?.() || 0;
      const hasRunRows = runCount > 0;
      const hasPending = hasRunRows && hasAnyPendingMaterial();
      const looksMaterial = hasRunRows && isMaterialBarcodeValue(barcodeValue);
      if (looksMaterial) {
        const ok = await onMaterialBarcodeScan(barcodeValue, true);
        if (!ok) {
          const target = getFirstPendingBarcodeTarget();
          if (target) {
            const targetLabel =
              (target?.nm_matl || "").toString().trim() ||
              (target?.cd_matl || "").toString().trim() ||
              "대상 품목";
            await showDialog("alter", `${targetLabel}의 바코드를 입력하세요.`);
          } else {
            await showDialog(
              "alter",
              "해당 자재는 이미 필요수량이 모두 스캔되었습니다."
            );
          }
        }
        setProdBarcode("");
        shouldRestoreProdFocusRef.current = true;
        if (ok && !hasAnyPendingMaterial()) {
          await autoSaveAndRefresh();
        }
        return;
      }

      // 자재 미입력 행이 남아있으면 입력값을 무조건 자재바코드로 처리한다.
      // 성공 시 해당 행 갱신, 실패 시 대상 품목 안내 메시지를 표시하고 제품실적 처리는 막는다.
      if (hasPending) {
        const ok = await onMaterialBarcodeScan(barcodeValue, true);
        if (!ok) {
          const target = getFirstPendingBarcodeTarget();
          const targetLabel =
            (target?.nm_matl || "").toString().trim() ||
            (target?.cd_matl || "").toString().trim() ||
            "대상 품목";
          await showDialog("alter", `${targetLabel}의 바코드를 입력하세요.`);
        }
        setProdBarcode("");
        shouldRestoreProdFocusRef.current = true;
        if (ok && !hasAnyPendingMaterial()) {
          await autoSaveAndRefresh();
        }
        return;
      }

      const panel1 = formPanel1Ref.current?.getFormdata?.() || {};
      const fgUnit = (panel1.fg_unit || "").toString();
      if (isDuplicateBarcode(barcodeValue, fgUnit)) {
        await new Promise((resolve) => setTimeout(resolve, 0));
        await showDialog("alter", "이미 등록된 정보입니다.");
        shouldRestoreProdFocusRef.current = true;
        return;
      }

      const addedCount = await addRunlRowByBarcode(barcodeValue, fgGoodBad);
      if (!addedCount) return;
      // 제품실적 바코드 스캔 성공 직후에만 투입자재 준비행을 생성한다.
      // 바코드 1회 스캔으로 runl이 여러 건 생성될 수 있어, 해당 runl 전건에 대해 생성한다.
      const createdRunLines: number[] = [];
      gridRefs.current["grid1"].current?.forEachNode?.((node: any) => {
        const row = node?.data || {};
        if ((row.barcode || "").toString() !== barcodeValue) return;
        const line = Number(row.no_line ?? 0) || 0;
        if (!line) return;
        if (!createdRunLines.includes(line)) {
          createdRunLines.push(line);
        }
      });
      if (createdRunLines.length > 0) {
        createdRunLines.forEach((line) => {
          prepareMaterialRowsForCurrentRunl(barcodeValue, line);
        });
      } else {
        prepareMaterialRowsForCurrentRunl(barcodeValue);
      }

      await recalcRunQtyToPanel();

      setProdBarcode("");
      shouldRestoreProdFocusRef.current = true;
      if (!hasAnyPendingMaterial()) {
        await autoSaveAndRefresh();
      }
    };

    // 투입자재 바코드 스캔 처리 (prd_issuel 조회 후 grid2 행 추가)
    const onMaterialBarcodeScan = async (
      barcodeValue: string,
      silent = false
    ) => {
      const debugFail = async (reason: string, extra?: Record<string, any>) => {
        if (silent) return;
        const rows = getAllGrid2Rows();
        const pendingCnt = rows.filter((r: any) => isMatlRowPending(r)).length;
        const lines = [
          `[MAT-SCAN DEBUG] ${reason}`,
          `scan:${(barcodeValue || "").toString()}`,
          `grid2.rows:${rows.length}`,
          `grid2.pending:${pendingCnt}`,
        ];
        if (extra) {
          Object.entries(extra).forEach(([k, v]) => {
            lines.push(`${k}:${v ?? ""}`);
          });
        }
        await showDialog("alter", lines.join("\n"));
      };

      const panel1 = formPanel1Ref.current?.getFormdata?.() || {};
      const noWo = panel1.no_wo || selectedData?.no_wo;
      if (!noWo) {
        await debugFail("작업지시 정보 없음", {
          panel_no_wo: panel1.no_wo || "",
          selected_no_wo: selectedData?.no_wo || "",
        });
        return false;
      }

      // 현재 처리 대상 실적항번(no_line_run) 결정
      // 1) 포커스된 grid1 행 우선
      // 2) 포커스 행에 pending 자재가 없으면, 전체 grid2에서 첫 pending 행의 no_line_run 사용
      const focusedNoLineRun =
        Number(getCurrentRunlLink()?.no_line_run ?? 0) || 0;
      let activeNoLineRun = focusedNoLineRun;
      if (activeNoLineRun > 0 && !hasPendingMaterialForRun(activeNoLineRun)) {
        activeNoLineRun = 0;
      }
      if (activeNoLineRun <= 0) {
        const firstPending = getAllGrid2Rows().find((row: any) =>
          isMatlRowPending(row)
        );
        activeNoLineRun = Number(firstPending?.no_line_run ?? 0) || 0;
      }

      // 투입자재 바코드 중복 스캔 방지
      // 정책: no_line_run이 다르면 동일 바코드 사용 가능
      let dup = false;
      getGridCurrent("grid2")?.forEachNode?.((node: any) => {
        if (dup) return;
        const row = node.data || {};
        if (
          Number(row?.no_line_run ?? 0) === activeNoLineRun &&
          normalizeBarcode(row.no_barcode) === normalizeBarcode(barcodeValue)
        ) {
          dup = true;
        }
      });
      if (dup) {
        await debugFail("이미 스캔된 바코드(동일 no_line_run)", {});
        return false;
      }

      const localHit = (partsListRef.current || []).find((p: any) => {
        const fg = (p?.fg_unit || "").toString().trim().toUpperCase();
        const sn = normalizeBarcode(p?.no_sn);
        const lot = normalizeBarcode(p?.no_lot);
        const v = normalizeBarcode(barcodeValue);
        if (fg === "SN" && sn === v) return getPartAvailableQty(p) > 0;
        if (fg === "LOT" && lot === v) return getPartAvailableQty(p) > 0;
        return false;
      });

      let iss = localHit || null;
      if (!iss) {
        await debugFail("partslist/prd_issuel에서 바코드 미매칭", {
          no_wo: noWo,
        });
        return false;
      }

      const cdMatl = (iss.cd_matl || "").toString().trim();
      // 동일 자재가 여러 no_line_bill로 존재하면 iss.no_line_bill 기준으로 매핑
      // partslist(issuel) 1건을 자재기준행(wobill) 1건에 매핑한다.
      // no_line_bill이 있으면 동일 자재코드 내에서도 자재항번까지 일치시킨다.
      const baseRow =
        matlCheckRows.find(
          (r: any) => (r.cd_matl || "").toString().trim() === cdMatl && true
        ) || null;

      if (!baseRow) {
        await debugFail("matlCheckRows에서 cd_matl/no_line_bill 매핑 실패", {
          iss_cd_matl: iss.cd_matl || "",
          iss_no_line_bill: Number(iss.no_line_bill ?? 0) || 0,
        });
        return false;
      }

      const qtRemain = Number(iss.qt_remain ?? 0) || 0;
      if (qtRemain <= 0) {
        await debugFail("qt_remain <= 0", {
          iss_qt_remain: qtRemain,
          iss_no_io: iss.no_io || "",
          iss_no_line_io: Number(iss.no_line_io ?? 0) || 0,
          iss_no_line_lot_io: Number(iss.no_line_lot_io ?? 0) || 0,
        });
        return false;
      }
      // partslist.qt_use를 반영한 현재 가용잔량
      const issKey = makePartKey(iss);
      const partRow = (partsListRef.current || []).find(
        (p: any) => makePartKey(p) === issKey
      );
      const effectiveRemain =
        partRow != null
          ? getPartAvailableQty(partRow)
          : qtRemain - (Number(iss.qt_use ?? 0) || 0);
      if (effectiveRemain <= 0) {
        await debugFail("effectiveRemain <= 0", {
          effectiveRemain,
          iss_qt_remain: qtRemain,
          part_qt_use: partRow ? Number(partRow.qt_use ?? 0) || 0 : 0,
        });
        return false;
      }
      const grid2Rows = getAllGrid2Rows();
      const pendingByMatl = grid2Rows.filter((row: any) => {
        if ((row.cd_matl || "").toString().trim() !== cdMatl) return false;
        if (!isMatlRowPending(row)) return false;
        if (
          activeNoLineRun > 0 &&
          Number(row.no_line_run ?? 0) !== activeNoLineRun
        )
          return false;
        if (
          Number(iss?.no_line_bill ?? 0) > 0 &&
          Number(row.no_line_bill ?? 0) !== Number(iss?.no_line_bill ?? 0)
        )
          return false;
        return true;
      });
      const target = pendingByMatl[0];

      if (!target) {
        await debugFail("대상 pending row 매칭 실패", {
          need_cd_matl: (cdMatl || "").toString(),
          need_no_line_bill: Number(iss?.no_line_bill ?? 0) || 0,
          active_no_line_run: activeNoLineRun,
          sample_rows: grid2Rows
            .slice(0, 8)
            .map(
              (r: any) =>
                `matl:${(r.cd_matl || "").toString()},bill:${Number(
                  r.no_line_bill ?? 0
                )},run:${Number(r.no_line_run ?? 0)},fg:${(
                  r.fg_unit || ""
                ).toString()},barcode:${(r.no_barcode || "").toString()}`
            )
            .join(" | "),
        });
        return false;
      }

      // prepare 단계에서 행별 필요수량을 qt로 분해해두므로 qt 우선 사용
      const targetQty =
        Number(target.qt ?? target.qt_w ?? target.qt_unit ?? 0) || 0;
      const appliedQty =
        targetQty > 0 ? Math.min(targetQty, effectiveRemain) : effectiveRemain;

      const scannedFgUnit = (iss.fg_unit || target.fg_unit || "")
        .toString()
        .toUpperCase();
      const resolvedBarcode = (barcodeValue || "").toString().trim();
      // 표시용 no_barcode와 저장용 no_sn/no_lot를 타입 기준으로 강제 동기화
      const resolvedNoSn = scannedFgUnit === "SN" ? resolvedBarcode : "";
      const resolvedNoLot = scannedFgUnit === "LOT" ? resolvedBarcode : "";

      const updatedRow = {
        ...target,
        no_barcode: resolvedBarcode,
        no_sn: resolvedNoSn,
        no_lot: resolvedNoLot,
        fg_unit: scannedFgUnit || iss.fg_unit,
        no_io: iss.no_io,
        no_line_io: iss.no_line_io,
        no_line_lot_io: iss.no_line_lot_io,
        no_origin: iss.no_origin,
        no_line_origin: iss.no_line_origin,
        no_line_lot_origin: iss.no_line_lot_origin,
        no_ct: iss.no_ct,
        no_plt: iss.no_plt,
        cd_wh: iss.cd_wh,
        qt: appliedQty,
        qt_w: appliedQty,
        qt_b: 0,
      };
      let nextGrid2Rows = grid2Rows.map((row: any) =>
        row === target ? updatedRow : row
      );
      let updated = false;
      getGridCurrent("grid2")?.forEachNode?.((node: any) => {
        if (updated) return;
        if (node?.data !== target) return;
        Object.entries(updatedRow).forEach(([k, v]) => {
          node.setDataValue?.(k, v, GRID_NO_EVENT);
        });
        updated = true;
      });
      // 수동 스캔행은 스캔 성공 시점에 qt_use를 누적한다.
      if (issKey && appliedQty > 0) {
        const used = new Map<string, number>();
        used.set(issKey, appliedQty);
        applyPartUseMap(used);
        // FE에서도 즉시 yn_check를 올려, 저장 전 다음 실적 입력 시 자동 바코드 주입이 가능하도록 한다.
        const nextParts = (partsListRef.current || []).map((p: any) => {
          if (makePartKey(p) !== issKey) return p;
          return {
            ...p,
            yn_check: "Y",
          };
        });
        partsListRef.current = nextParts;
        setPartsListRows(nextParts);
      }

      // 선택한 바코드 잔량이 대상 필요수량보다 작으면 부족분 행을 추가하여 추가 스캔 가능하게 유지
      if (targetQty > appliedQty) {
        const remainQty = targetQty - appliedQty;
        const remainRow = {
          ...target,
          qt: remainQty,
          qt_w: remainQty,
          qt_b: 0,
          no_barcode: "",
          no_sn: "",
          no_lot: "",
          no_io: "",
          no_line_io: 0,
          no_line_lot_io: 0,
          no_origin: "",
          no_line_origin: 0,
          no_line_lot_origin: 0,
          no_ct: "",
          no_plt: "",
          cd_wh: "",
        };
        nextGrid2Rows = [...nextGrid2Rows, remainRow];
        getGridCurrent("grid2")?.addRow?.(remainRow, false);
      }

      setDataSources((prev: any) => ({
        ...prev,
        grid2: nextGrid2Rows,
      }));

      focusProductBarcode();
      return true;
    };

    // Grid addRow 직전, 대기 큐에서 1건을 꺼내 실제 row 데이터를 구성한다.
    const onBeforeAddRunlRow = () => {
      try {
        const pending = pendingRunlQueueRef.current.shift();
        if (!pending) return {};

        const maxNoLine =
          gridRefs.current["grid1"].current?.getMaxValue?.("no_line") ?? 0;
        const fgUnit = (pending.fgUnit || "LOT")
          .toString()
          .trim()
          .toUpperCase();
        const fgGoodBad = (pending.fgGoodBad || "G").toString();
        const scannedBarcode = (pending.barcodeValue || "").toString();
        const newRow: any = {
          cd_firm: userInfo.cd_firm,
          no_run: pending.noRun,
          no_line: maxNoLine + 1,
          fg_unit: fgUnit,
          no_barcode: scannedBarcode,
          no_run_prev: pending.noRunPrev,
          qt_w: 1,
          qt_b: fgGoodBad === "B" ? 1 : 0,
          qt: 1,
          ...(fgUnit === "SN"
            ? { no_sn: scannedBarcode, no_lot: "" }
            : { no_sn: "", no_lot: scannedBarcode }),
        };

        return newRow;
      } catch (error: any) {
        pendingRunlQueueRef.current = [];
        return false;
      }
    };

    // 작업일 기준으로 근무일/작업조를 조회한다(fn_prd_dt_work).
    const loadWorkDateInfo = async (dtRun?: string) => {
      const targetDate = (dtRun || dateToString(new Date())).toString();
      const payload = {
        id: "fn_prd_dt_work",
        params: {
          cd_firm: userInfo.cd_firm,
          dt: targetDate,
        },
      };

      const data: any = await fnGetTableById(payload);
      if (Array.isArray(data) && data.length > 0) {
        return {
          dt_run: data[0].dt_work || targetDate,
          cd_shift: data[0].cd_flag || "",
        };
      }

      return {
        dt_run: targetDate,
        cd_shift: "",
      };
    };

    // dt_run 변경 시 작업일/작업조를 재조회해 panel3 값을 동기화한다.
    const onPanel2ValueChanged = async (event: any) => {
      if (event.colId !== "dt_run") return {};
      const nextDate = (event.newValue || "").toString();
      if (!nextDate) return {};

      try {
        const workInfo = await loadWorkDateInfo(nextDate);
        if (workInfo.dt_run && workInfo.dt_run !== nextDate) {
          await formPanel2Ref.current?.setDataValue?.(
            "dt_run",
            workInfo.dt_run,
            "noEvent"
          );
        }
        await formPanel2Ref.current?.setDataValue?.(
          "cd_shift",
          workInfo.cd_shift || "",
          "noEvent"
        );
      } catch (error: any) {
        showDialog("error", error.message);
      }
      return {};
    };

    // 제품바코드 라벨 출력 (reportName + { no_sn, nm_item })
    const onPrint = async (
      reportName: string,
      noSn: string,
      nmItem: string
    ) => {
      const report = (reportName || "").toString().trim();
      const no_sn = (noSn || "").toString().trim();
      if (!report || !no_sn) return;

      // 파라미터 구성은 PRD_LABEL_PRINT에 모아둔다(라벨 재출력과 동일 기준).
      await fnPrintByReport(report, buildPrdLabelParams(nmItem, no_sn));
    };

    const resetIssuedRunHeader = async () => {
      await formPanel2Ref.current?.setDataValue?.("no_run", "", GRID_NO_EVENT);
      await formPanel2Ref.current?.setDataValue?.("no_cons", "", GRID_NO_EVENT);
    };

    useImperativeHandle(ref, () => ({
      getSelectedValue: async () => {
        if (isRunViewMode) {
          return { excelUpload: false };
        }
        const result = await onSave({ silentSuccess: true });
        if (result === true) {
          await resetIssuedRunHeader();
          await onSearch();
          setDataSources((prev: any) => ({ ...prev, grid2: [] }));
          // WP3003는 저장 후 팝업을 닫지 않고, 초기화 상태로 계속 등록한다.
          return { excelUpload: false };
        }
        return { excelUpload: false };
      },
    }));

    // 탭 전환 시 해당 입력칸으로 포커스를 이동해 스캔 동선을 유지한다.
    useEffect(() => {
      const runCount = getGridCurrent("grid1")?.getDisplayedRowCount?.() || 0;
      // 초기 상태(실적행 없음)에서는 탭이 투입자재여도 제품바코드부터 시작한다.
      if (runCount < 1) {
        focusProductBarcode();
        return;
      }
      restoreBarcodeFocus();
    }, [tab]);

    useEffect(() => {
      if (!shouldRestoreProdFocusRef.current) return;
      if ((prodBarcode || "").toString().trim()) return;
      shouldRestoreProdFocusRef.current = false;
      restoreBarcodeFocus();
    }, [dataSources.grid1, dataSources.grid2, prodBarcode]);

    useEffect(() => {
      setPopupParentEl(popupRootRef.current);
    }, []);

    // 팝업 최초 오픈: 컨트롤/기본값 세팅 후 초기 조회를 수행한다.
    useEffect(() => {
      const fetchform = async () => {
        try {
          const rtn: any = await getInitPopUpData("SN_PRD_POP_WP3003", {});
          const form1 = rtn.form.form1 || [];
          const form2 = rtn.form.form2 || [];

          const workInfo = await loadWorkDateInfo(dateToString(new Date()));
          const panel2Defaults = {
            dt_run: workInfo.dt_run,
            tm_start: getNowTime(),
            tm_end: getNowTime(),
            cd_emp: userInfo.cd_emp,
            nm_emp: userInfo.nm_emp,
            fg_run: selectedData?.fg_run || "S",
            cd_shift: workInfo.cd_shift || "A",
          };

          setPanel1Controls(toReadOnlyControls(form1));
          setPanel2Controls(toReadOnlyControls(form2));
          setPanel1Data(rtn.form.form1ControlData || {});
          setPanel2Data({
            ...(rtn.form.form2ControlData || {}),
            ...panel2Defaults,
          });
          setColums({
            grid1: rtn.grid.grid1 || [],
            grid2: rtn.grid.grid2 || [],
            grid3: rtn.grid.grid3 || [],
          });
          await new Promise((resolve) => setTimeout(resolve, 0));
          await onSearch();
        } catch (error: any) {
          showDialog("error", error.message);
        }
      };
      fetchform();
    }, []);

    // 팝업 기본 조회(panel1 header + grid1/grid2).
    const prepareRunNoForAttachment = async () => {
      const selectedNoRun = (selectedData?.no_run || "").toString().trim();
      if (selectedNoRun) {
        setSelectedDocu(selectedNoRun);
        setSelectedLineDocu(0);
        await formPanel2Ref.current?.setDataValue?.(
          "no_run",
          selectedNoRun,
          GRID_NO_EVENT
        );
        return selectedNoRun;
      }

      const runhData = formPanel2Ref.current?.getFormdata?.() || {};
      const dtRun =
        runhData.dt_run || panel2Data?.dt_run || dateToString(new Date());
      const cd_module: any = Menuprops?.cd_module;
      const cd_menu: any = Menuprops?.cd_menu;
      if (!cd_module || !cd_menu || !dtRun) {
        setSelectedDocu("");
        setSelectedLineDocu(0);
        return "";
      }

      const noRun = await getAutoSlip(cd_module, 2, dtRun, cd_menu);
      const nextNoRun = (noRun || "").toString().trim();
      setSelectedDocu(nextNoRun);
      setSelectedLineDocu(0);
      setPanel2Data((prev: any) => ({ ...(prev || {}), no_run: nextNoRun }));
      await formPanel2Ref.current?.setDataValue?.(
        "no_run",
        nextNoRun,
        GRID_NO_EVENT
      );
      return nextNoRun;
    };

    const onSearchRunView = async () => {
      const noRun = (selectedData?.no_run || "").toString().trim();
      if (!noRun) return;

      const params = {
        id: "sn_prd_wrk_reg_001_pop_run_01",
        params: {
          cd_firm: userInfo.cd_firm,
          no_run: noRun,
        },
      };

      const data: any = await fnGetDataSet(params);
      const woHeader = data?.[0]?.[0] || {};
      const runh = data?.[1]?.[0] || {};
      const runlRows = Array.isArray(data?.[2]) ? data[2] : [];
      const inspRows = Array.isArray(data?.[4]) ? data[4] : [];
      const conslRows = Array.isArray(data?.[6]) ? data[6] : [];

      setPanel1Data(woHeader);
      setPanel2Data({ ...runh, no_run: noRun });
      setMatlCheckRows([]);
      partsListRef.current = [];
      setPartsListRows([]);
      setHasMatlCheck(conslRows.length > 0);
      pendingRunlQueueRef.current = [];
      setProdBarcode("");
      hasRunlInspRowsRef.current = inspRows.length > 0;
      setDataSources({
        grid1: runlRows,
        grid2: conslRows,
        grid3: inspRows,
      });
      setTab(conslRows.length > 0 ? TAB_REJECT : TAB_MATERIAL);
      await prepareRunNoForAttachment();
    };

    const onSearch = async () => {
      try {
        if (isRunViewMode) {
          await onSearchRunView();
          return;
        }

        const params = {
          id: "sn_prd_wrk_reg_001_pop_01",
          params: {
            cd_firm: userInfo.cd_firm,
            no_wo: selectedData?.no_wo,
            no_line: selectedData?.no_line,
          },
        };

        const data: any = await fnGetDataSet(params);
        const header = data?.[0]?.[0] || {};
        // sn_prd_wrk_reg_001_pop_01 반환 테이블은 변경될 수 있어
        // 컬럼 존재 기준으로 안전하게 테이블을 식별한다.
        // 투입자재 기준 리스트: yn_matl_check 포함 + 재고키(no_io)가 없는 테이블
        // (partslist가 yn_matl_check를 같이 내려줄 수 있어 조건을 분리한다.)
        // Fixed order contract: [0]=header, [1]=matlCheckList, [2]=partsList, [3]=runlInspList.
        const {
          matlCheckList: matlCheckListRaw,
          partsList,
          runlInspList,
        } = resolveWrkRegPopupTables(data);
        const matlCheckList = isRework ? [] : matlCheckListRaw;
        hasRunlInspRowsRef.current = Array.isArray(runlInspList)
          ? runlInspList.length > 0
          : false;

        // partslist: 재고키(no_io/no_line_io/no_line_lot_io)와 잔량(qt_remain) 포함
        // Y 대상만 grid2 기본행으로 노출한다.
        // N 대상은 저장 직전 자동소진 로직으로 prd_consl에 합산한다.
        const matlCheckFiltered = matlCheckList.filter((row: any) =>
          isYnY(row?.yn_matl_check)
        );
        const hasMatlCheckY = matlCheckFiltered.length > 0;

        setPanel1Data(header);
        setMatlCheckRows(matlCheckList);
        partsListRef.current = partsList;
        setPartsListRows(partsList);
        setHasMatlCheck(hasMatlCheckY);
        pendingRunlQueueRef.current = [];
        setProdBarcode("");
        const initialGrid2Rows = buildInitialGrid2Rows(
          matlCheckList,
          partsList,
          runlInspList
        );
        setDataSources({
          grid1: [],
          // grid2는 화면 오픈 시 바로 바인딩하지 않는다.
          // 제품바코드 스캔 시점에 현재 runl 기준으로 필요한 행만 생성한다.
          grid2: initialGrid2Rows,
          grid3: runlInspList,
        });
        // 투입자재 탭은 Y 대상이 있을 때만 의미가 있으므로 기본 탭 분기
        setTab(hasMatlCheckY ? TAB_REJECT : TAB_MATERIAL);
        await prepareRunNoForAttachment();
        // 팝업 오픈/재조회 직후 최초 입력은 항상 제품바코드에서 시작
        focusProductBarcode();
      } catch (error: any) {
        showDialog("error", error.message);
      }
    };

    // 저장 전 필수 스캔자재(YN_MATL_CHECK='Y') 누락 여부를 검증한다.
    const validateMaterialRowsBeforeSave = async (grid2Rows: any[]) => {
      const validationResult = validateMaterialRowsBeforeSaveCommon(
        hasMatlCheck,
        grid2Rows
      );
      if (validationResult.ok) return true;

      if (validationResult.reason === "no_rows") {
        await showDialog("alter", "투입자재 스캔 내역이 없습니다.");
        setTab(TAB_REJECT);
        restoreBarcodeFocus();
        return false;
      }

      const missingBarcode = validationResult.row;
      const matlCode = (missingBarcode?.cd_matl || "").toString().trim();
      const matlName = (missingBarcode?.nm_matl || "").toString().trim();
      await showDialog(
        "alter",
        `투입자재[${matlCode} : ${matlName}]의 바코드가 누락된 행이 존재합니다.`
      );
      setTab(TAB_REJECT);
      setTimeout(() => {
        const rowIndex = grid2Rows.findIndex(
          (row: any) => row === missingBarcode
        );
        if (rowIndex > -1)
          getGridCurrent("grid2")?.selectAndFocusRow?.(rowIndex);
        if (rowIndex > -1)
          getGridCurrent("grid2")?.setFocusedCell?.(rowIndex, "no_barcode");
      }, 60);
      return false;
    };

    // grid2(스캔 입력) 기반 prd_consl insert payload 생성
    const buildManualConslInsert = (grid2Rows: any[], noRun: string) => {
      // 공통 저장헬퍼: prd_consl.insert row 생성
      return buildManualConslInsertRows(userInfo.cd_firm, grid2Rows, noRun);
    };

    // Y/N 혼재 처리: Y가 아닌 자재를 자동소진으로 배분해 prd_consl row 생성
    const buildAutoConsumeConsl = async (noRun: string) => {
      if (!hasMatlCheck) return [] as any[];
      const nMatls = matlCheckRows.filter(
        (row: any) => !isYnY(row?.yn_matl_check)
      );
      if (nMatls.length < 1) return [] as any[];

      const autoConsl: any[] = [];
      for (const matl of nMatls) {
        const qtNeed = Number(matl.qt_unit ?? 0) || 0;
        if (qtNeed <= 0) continue;

        const payload = {
          id: ISSUE_REMAIN_QUERY_ID,
          params: {
            cd_firm: userInfo.cd_firm,
            cd_matl: matl.cd_matl,
            no_wo: selectedData?.no_wo,
          },
        };
        const result: any = await fnGetTableById(payload);
        const issuelList = Array.isArray(result) ? result : [];

        let remainNeed = qtNeed;
        for (const iss of issuelList) {
          const qtRemain = Number(iss.qt_remain ?? 0) || 0;
          if (qtRemain <= 0) continue;
          const useQty = Math.min(remainNeed, qtRemain);

          autoConsl.push({
            cd_firm: userInfo.cd_firm,
            no_run: noRun,
            no_line: 0,
            cd_matl: matl.cd_matl,
            no_line_bill: matl.no_line_bill,
            no_line_run: 0,
            fg_unit: iss.fg_unit,
            no_lot: iss.no_lot,
            no_sn: iss.no_sn,
            qt: useQty,
            qt_w: useQty,
            qt_b: 0,
            no_io: iss.no_io,
            no_line_io: iss.no_line_io,
            no_line_lot_io: iss.no_line_lot_io,
            no_origin: iss.no_origin,
            no_line_origin: iss.no_line_origin,
            no_line_lot_origin: iss.no_line_lot_origin,
            no_ct: iss.no_ct,
            no_plt: iss.no_plt,
            cd_wh: iss.cd_wh,
          });

          remainNeed -= useQty;
          if (remainNeed <= 0) break;
        }

        if (remainNeed > 0) {
          const matlLabel = `${matl.cd_matl || ""}`;
          await showDialog(
            "alter",
            `[${matlLabel}] 재고가 부족합니다. 부족수량: ${remainNeed}`
          );
          return null;
        }
      }
      return autoConsl;
    };

    // 스캔필수(Y) 자재의 소요량(qt_unit) 충족 여부를 최종 검증
    const validateYMaterialNeed = async (conslRows: any[]) => {
      if (!hasMatlCheck) return true;
      // 공통 저장헬퍼: Y 자재 소요량 부족 계산
      const shortageInfo = findYMaterialShortage(matlCheckRows, conslRows);
      if (shortageInfo) {
        await showDialog(
          "alter",
          `[${shortageInfo.matlCode}] 소요수량이 부족합니다. 부족수량: ${shortageInfo.shortage}\n추가 바코드 스캔 후 저장하세요.`
        );
        setTab(TAB_REJECT);
        restoreBarcodeFocus();
        return false;
      }
      return true;
    };

    // prd_consl -> prd_issuel 연결키 정합성 검증
    // (cd_firm,no_io,no_line_io,no_line_lot_io) 누락 시 저장 전 차단
    const validateConslIssueKeys = async (conslRows: any[]) => {
      // 공통 저장헬퍼: 연결키 누락 행 탐지
      const invalid = findInvalidConslIssueKeyRow(conslRows);
      if (!invalid) return true;

      const matlLabel = `${invalid.cd_matl || ""}`;
      await showDialog(
        "alter",
        `[${matlLabel}] 재고 연결키(no_io/no_line_io/no_line_lot_io)가 누락되었습니다.`
      );
      setTab(TAB_REJECT);
      restoreBarcodeFocus();
      return false;
    };

    // 투입번호(no_cons) 채번 후 prd_consh 1건을 생성한다.
    const issueNoConsAndBuildConsh = async (runhData: any, panel1Data: any) => {
      if (!hasMatlCheck) return { no_cons: "", conshInsert: [] as any[] };
      if (!runhData.dt_run) {
        await showDialog("alter", "실적일이 없습니다.");
        return null;
      }
      const cd_module: any = Menuprops?.cd_module;
      if (!cd_module) {
        await showDialog(
          "error",
          "전표 채번 모듈 정보가 없습니다. 관리자에게 문의하세요."
        );
        return null;
      }
      const no_cons = await getAutoSlip(
        cd_module,
        61,
        runhData.dt_run,
        "SN_PRD_WRK_REG_001"
      );
      if (!no_cons) {
        await showDialog("error", "투입번호 채번에 실패했습니다.");
        return null;
      }

      const ynBf = (matlCheckRows[0]?.yn_bf || "N").toString();
      // 공통 저장헬퍼: prd_consh.insert 생성
      const conshInsert = buildConshInsertRows(
        userInfo.cd_firm,
        no_cons,
        runhData.no_run,
        selectedData?.no_wo,
        selectedData?.no_line,
        panel1Data.cd_op,
        ynBf,
        runhData.dt_run
      );
      return { no_cons, conshInsert };
    };

    // 저장: no_run 채번 -> runh/runl payload 구성 -> fnSave.
    const onSave = async (options?: {
      silentNoChanges?: boolean;
      silentSuccess?: boolean;
    }) => {
      try {
        gridRefs.current["grid1"].current?.stopEditing();

        const runhData = formPanel2Ref.current?.getFormdata?.() || {};
        const panel1Data = formPanel1Ref.current?.getFormdata?.() || {};
        let runlChanges =
          gridRefs.current["grid1"].current?.getChange?.() || {};
        let grid2Rows: any[] = getAllGrid2Rows();
        const grid3Rows = collectRowsFromGrid(
          gridRefs.current["grid3"].current,
          dataSources?.grid3,
          true
        );

        const hasRunlChanges = Number(runlChanges.modifiedRowcount ?? 0) > 0;
        const hasGrid2Rows = (grid2Rows || []).length > 0;
        if (!hasRunlChanges && !hasGrid2Rows) {
          if (!options?.silentNoChanges) {
            await showDialog("alter", "변경된 내용이 없습니다.");
          }
          return false;
        }

        let no_run = runhData.no_run;
        if (!no_run) {
          const cd_module: any = Menuprops?.cd_module;
          const cd_menu: any = Menuprops?.cd_menu;
          if (!cd_module || !cd_menu) {
            await showDialog(
              "error",
              "실적번호 채번 정보가 없습니다. 관리자에게 문의하세요."
            );
            return false;
          }
          if (!runhData.dt_run) {
            await showDialog("alter", "실적일이 없습니다.");
            return false;
          }
          no_run = await getAutoSlip(cd_module, 2, runhData.dt_run, cd_menu);
          if (!no_run) {
            await showDialog("error", "실적번호 채번에 실패했습니다.");
            return false;
          }
        }

        runhData.no_run = no_run;
        if (
          Array.isArray(runlChanges.insert) &&
          runlChanges.insert.length > 0
        ) {
          runlChanges.insert.forEach((row: any) => {
            if (!row.no_run) {
              row.no_run = no_run;
            }
          });
          getGridCurrent("grid1")?.forEachNode?.((node: any) => {
            if (!node.data?.no_run) {
              node.setDataValue("no_run", no_run);
            }
          });
          // 제품실적과 연결된 투입자재 행에도 no_run 보정
          getGridCurrent("grid2")?.forEachNode?.((node: any) => {
            if (!node?.data?.no_run) {
              node.setDataValue("no_run", no_run, GRID_NO_EVENT);
            }
          });
        }

        // 투입자재 지정이 필요한 경우(yn_matl_check=Y 존재) 저장 전 검증
        const validMaterialRows =
          await validateMaterialRowsBeforeSave(grid2Rows);
        if (!validMaterialRows) {
          return false;
        }

        // WP3003: 저장 직전에 제품바코드를 채번하여 제품바코드 칸(no_barcode_item)에 반영
        const noBsn = await getbsnget(
          "ITEM",
          panel1Data.cd_item || selectedData?.cd_item || "",
          "",
          runhData.dt_run || "",
          1,
          1,
          "Y",
          ""
        );
        if (!noBsn) {
          await showDialog("error", "제품바코드 채번에 실패했습니다.");
          return false;
        }

        // 제품 스캔 없이 저장하는 WP3003 시나리오:
        // grid1 변경이 없으면 채번된 no_bsn으로 prd_runl 1건을 강제 생성한다.
        let runlLineNo =
          Number(getGridCurrent("grid1")?.getMaxValue?.("no_line") ?? 0) + 1;
        if (!hasRunlChanges) {
          const fgUnitRaw = (panel1Data.fg_unit || "SN")
            .toString()
            .trim()
            .toUpperCase();
          const fgUnit = fgUnitRaw === "LOT" ? "LOT" : "SN";
          const qtW = 1;
          const qtB = Number(runhData.qt_b ?? 0) || 0;
          const qt = 1;
          const runlInsert: any = {
            cd_firm: userInfo.cd_firm,
            no_run,
            no_line: runlLineNo,
            fg_unit: fgUnit,
            no_barcode: noBsn,
            no_run_prev: "",
            qt_w: qtW,
            qt_b: qtB,
            qt,
            ...(fgUnit === "SN"
              ? { no_sn: noBsn, no_lot: "" }
              : { no_sn: "", no_lot: noBsn }),
          };
          runlChanges = {
            ...runlChanges,
            insert: [
              ...(Array.isArray(runlChanges.insert) ? runlChanges.insert : []),
              runlInsert,
            ],
            modifiedRowcount: Number(runlChanges.modifiedRowcount ?? 0) + 1,
          };
        } else {
          const firstRunl =
            Array.isArray(runlChanges.insert) && runlChanges.insert.length > 0
              ? runlChanges.insert[0]
              : null;
          if (firstRunl?.no_line) {
            runlLineNo = Number(firstRunl.no_line) || runlLineNo;
          }
        }
        grid2Rows = grid2Rows.map((row: any) => ({
          ...row,
          no_run,
          no_line_run: Number(row?.no_line_run ?? 0) || runlLineNo,
          no_barcode_item: noBsn,
        }));
        getGridCurrent("grid2")?.forEachNode?.((node: any) => {
          node.setDataValue?.("no_run", no_run, GRID_NO_EVENT);
          if (!(Number(node?.data?.no_line_run ?? 0) > 0)) {
            node.setDataValue?.("no_line_run", runlLineNo, GRID_NO_EVENT);
          }
          node.setDataValue?.("no_barcode_item", noBsn, GRID_NO_EVENT);
        });
        setDataSources((prev: any) => ({
          ...prev,
          grid2: grid2Rows,
        }));

        const runlInspInsert = (grid3Rows || []).map((row: any) => ({
          ...row,
          no_run: runhData.no_run,
        }));

        const savePayload: any = {
          prd_runh: {
            insert: [
              {
                ...runhData,
                cd_firm: userInfo.cd_firm,
                no_wo: selectedData?.no_wo,
                no_line_wo: selectedData?.no_line,
                cd_op: panel1Data.cd_op,
                st_run: "R",
                cd_item: panel1Data.cd_item,
                qt: 1,
                qt_w: 1,
                yn_auto: runhData?.yn_auto || "N",
                yn_end: panel1Data.yn_end,
                cd_wh: panel1Data.cd_wh,
                cd_gp: userInfo.cd_gp,
                cd_dept: userInfo.cd_dept,
              },
            ],
            update: [],
            delete: [],
          },
          prd_runl: runlChanges,
          prd_consh: { insert: [], update: [], delete: [] },
          prd_consl: { insert: [], update: [], delete: [] },
          prd_runl_insp: { insert: runlInspInsert, update: [], delete: [] },
        };

        if (hasMatlCheck) {
          // prd_consl 생성: grid2 row 기반 (no_cons는 후반에 일괄 주입)
          // no_io/no_line_io/no_line_lot_io는 BE의 prd_issuel yn_check 갱신 키로도 사용된다.
          savePayload.prd_consl.insert = buildManualConslInsert(
            grid2Rows,
            runhData.no_run
          );
        }

        // YN_MATL_CHECK 혼재 시, 'N' 자재는 자동 소진되도록 저장 직전에 분배 처리
        if (hasMatlCheck) {
          const autoConsl = await buildAutoConsumeConsl(runhData.no_run);
          if (autoConsl === null) {
            return false;
          }
          if (autoConsl.length > 0) {
            // 기존 스캔 row 뒤에 자동 소진 row를 이어 붙임
            savePayload.prd_consl.insert = [
              ...savePayload.prd_consl.insert,
              ...autoConsl.map((row, idx) => ({
                ...row,
                no_line: (savePayload.prd_consl.insert?.length || 0) + idx + 1,
              })),
            ];
          }
        }

        if (hasMatlCheck) {
          // Y 자재(스캔필수)와 N 자재(자동소진)를 합쳐서 최종 prd_consl payload를 만든다.
          const validNeed = await validateYMaterialNeed(
            savePayload.prd_consl.insert || []
          );
          if (!validNeed) {
            return false;
          }
          // const validIssueKeys = await validateConslIssueKeys(
          //   savePayload.prd_consl.insert || []
          // );
          // if (!validIssueKeys) {
          //   return false;
          // }

          const noConsInfo = await issueNoConsAndBuildConsh(
            runhData,
            panel1Data
          );
          if (!noConsInfo) {
            return false;
          }

          // prd_consl에 no_cons 주입
          savePayload.prd_consl.insert = (
            savePayload.prd_consl.insert || []
          ).map((row: any) => ({
            ...row,
            no_cons: noConsInfo.no_cons,
          }));

          // prd_consh 생성 (실적 기준 1건)
          savePayload.prd_consh.insert = noConsInfo.conshInsert;
        }

        const saveResult = await fnSave(
          "SN_PRD_WRK_REG_001_SAVE_01",
          savePayload,
          undefined,
          { silentSuccess: options?.silentSuccess === true }
        );
        if (saveResult === false) {
          return false;
        }

        // 저장 성공 후(onSearch 전에) 자동 제품바코드 라벨 출력
        const isPrdBarcodeAuto = isYnY(panel1Data?.yn_prd_barcode_auto);
        const nmPrdReport = (panel1Data?.nm_prd_report || "").toString().trim();
        if (isPrdBarcodeAuto && nmPrdReport && noBsn) {
          try {
            await onPrint(
              nmPrdReport,
              noBsn,
              panel1Data?.nm_item || selectedData?.nm_item || ""
            );
          } catch (printError: any) {
            if (options?.silentSuccess !== true) {
              await showDialog(
                "alter",
                "저장은 완료되었습니다. 라벨 출력에 실패했습니다."
              );
            }
          }
        }
        gridRefs.current["grid1"].current?.resetUpdate();
        gridRefs.current["grid2"].current?.resetUpdate();
        gridRefs.current["grid3"].current?.resetUpdate();
        // 저장 직후 패널 수량은 전부 0으로 되돌린다.
        // 리셋이 없으면 스캔 누적값이 그대로 남아 다음 실적으로 이월된다.
        await formPanel2Ref.current?.setDataValue?.("qt_w", 0, "noEvent");
        await formPanel2Ref.current?.setDataValue?.("qt_b", 0, "noEvent");
        await formPanel2Ref.current?.setDataValue?.("qt", 0, "noEvent");
        return true;
      } catch (error: any) {
        showDialog("error", error.message);
        return false;
      }
    };

    const autoSaveAndRefresh = async () => {
      if (isRunViewMode) return false;
      if (hasRunlInspRowsRef.current) return false;
      if (isAutoSavingRef.current) return false;
      isAutoSavingRef.current = true;
      try {
        const saved = await onSave({
          silentNoChanges: true,
          silentSuccess: true,
        });
        if (!saved) return false;
        await resetIssuedRunHeader();
        await onSearch();
        restoreBarcodeFocus();
        return true;
      } catch (error) {
        return false;
      } finally {
        isAutoSavingRef.current = false;
      }
    };

    const grids = useMemo(
      () => ({
        grid1: {
          columns: columns.grid1,
          dataSource: dataSources.grid1,
          events: {
            onBeforeAddRow: onBeforeAddRunlRow,
            onCellFocused: onGridCellFocusedKeepBarcode,
          },
        },
        grid2: {
          columns: columns.grid2,
          dataSource: dataSources.grid2,
          events: {
            onCellFocused: onGridCellFocusedKeepBarcode,
          },
        },
        grid3: {
          columns: columns.grid3,
          dataSource: dataSources.grid3,
          events: {},
        },
      }),
      [columns, dataSources]
    );

    return (
      <div
        ref={popupRootRef}
        className="h-full flex flex-col space-y-2 overflow-hidden"
      >
        <div className="p-2 min-h-[150px]">
          <SnTab
            titles={["지시정보"]}
            width={"100%"}
            selectedTab={"1"}
            onTabChanged={() => {}}
            header={
              <div className="flex justify-end gap-2">
                <SnButton
                  visible={false}
                  text="작업표준서"
                  onClick={() => {
                    showDialog("alter", "작업표준서 기능은 준비중입니다.");
                  }}
                />
                <SnButton
                  visible={false}
                  text="작업사양서"
                  onClick={() => {
                    showDialog("alter", "작업사양서 기능은 준비중입니다.");
                  }}
                />
              </div>
            }
            body={[
              <SnForm
                ref={formPanel1Ref}
                data={panel1Data}
                controls={panel1Controls}
              />,
            ]}
          />
        </div>
        <div className="p-2 min-h-[150px]">
          <SnTab
            titles={["실적정보"]}
            width={"100%"}
            selectedTab={"1"}
            onTabChanged={() => {}}
            body={[
              <SnForm
                ref={formPanel2Ref}
                data={panel2Data}
                controls={panel2Controls}
                etcProps={{ gridAlign: "start", allowXScroll: false }}
                events={{ onValueChanged: onPanel2ValueChanged }}
              />,
            ]}
          />
        </div>
        <div className="flex-1 min-h-0 flex w-full" ref={panel2WrapperRef}>
          <div className="min-h-0 h-full w-full flex flex-col gap-2">
            <SnTabHeader
            // onBtnAddClick={() => {
            //   gridRefs.current["grid1"].current?.addRow();
            // }}
            // onBtnDeleteClick={() => {
            //   gridRefs.current["grid1"].current?.deleteSelectedRows();
            // }}
            />
            <div className="min-h-0 h-full w-full flex gap-2">
              <SnResizeBar direction="width" id="panel_prod" orgSize="30%">
                <div className="min-h-0 h-full w-full flex flex-col overflow-visible">
                  <SnTab
                    titles={["생산실적"]}
                    width={"100%"}
                    selectedTab={"1"}
                    onTabChanged={() => {}}
                    header={
                      <div className="flex items-center gap-2 p-1 w-full justify-end flex-nowrap">
                        <div className="w-44">
                          <SnBarcodeBox
                            popupRef={popupRootRef}
                            inputRef={prodBarcodeRef}
                            isReadOnly={isRunViewMode}
                            onEnter={handleProductionBarcodeSubmit}
                          />
                        </div>
                        <label className="flex items-center gap-1 whitespace-nowrap">
                          <input
                            type="radio"
                            checked={fgGoodBad === "G"}
                            disabled={isRunViewMode}
                            onChange={() => setFgGoodBad("G")}
                          />
                          양품
                        </label>
                        <label className="flex items-center gap-1 whitespace-nowrap">
                          <input
                            type="radio"
                            checked={fgGoodBad === "B"}
                            disabled={isRunViewMode}
                            onChange={() => setFgGoodBad("B")}
                          />
                          불량
                        </label>
                      </div>
                    }
                    body={[
                      <div className="min-h-0 h-full w-full flex flex-col">
                        <SnGrid
                          ref={gridRefs.current["grid1"]}
                          popupParent={popupParentEl || undefined}
                          columnConfig={grids.grid1.columns}
                          rowData={grids.grid1.dataSource}
                          etcProps={{
                            rowSelection: "single",
                            isEditable: !isRunViewMode,
                          }}
                          events={grids.grid1.events}
                        />
                      </div>,
                    ]}
                  />
                </div>
              </SnResizeBar>
              <div className="min-h-0 h-full flex-1">
                <SnTab
                  titles={["투입자재", "검사항목"]}
                  width={"100%"}
                  selectedTab={tab}
                  onTabChanged={(index: any) => {
                    // YN_MATL_CHECK가 없으면 투입자재 탭으로 이동하지 않음
                    if (index === TAB_REJECT && !hasMatlCheck) {
                      showDialog("alter", "투입자재 지정 대상이 없습니다.");
                      setTab(TAB_MATERIAL);
                      return;
                    }
                    setTab(index);
                  }}
                  header={[
                    <div className="w-full" />,
                    <div className="w-full" />,
                  ]}
                  body={[
                    <div className="min-h-0 h-full w-full flex flex-col">
                      <SnGrid
                        ref={gridRefs.current["grid2"]}
                        popupParent={popupParentEl || undefined}
                        columnConfig={grids.grid2.columns}
                        rowData={grids.grid2.dataSource}
                        etcProps={{
                          rowSelection: "single",
                        }}
                        events={grids.grid2.events}
                      />
                    </div>,
                    <div className="min-h-0 h-full w-full flex flex-col">
                      <SnGrid
                        ref={gridRefs.current["grid3"]}
                        popupParent={popupParentEl || undefined}
                        columnConfig={grids.grid3.columns}
                        rowData={grids.grid3.dataSource}
                        etcProps={{
                          rowSelection: "single",
                        }}
                        events={grids.grid3.events}
                      />
                    </div>,
                  ]}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="px-2 pb-2">
          <SnFileUploadBox
            selectedDocu={selectedDocu}
            selectedLineDocu={selectedLineDocu}
          />
        </div>
      </div>
    );
  }
);

export default WP3003;
